export const getSessions = state => {
    return state.sessions;
}